import {ApiResponse, PaginatedApiReponse} from '../models/ApiResponse';
import {CreatePostPayload, PostListItem} from '../models/Posts/Post';
import {ProjectFilter} from '../models/Projects/Project';
import {apiClient} from './baseApiClient';

class PostsApi {
  public async getPosts(
    organizationId: string,
    page: number,
    pageSize: number,
    search?: string,
    filter?: ProjectFilter,
  ): Promise<PaginatedApiReponse<PostListItem>> {
    return apiClient.post(`/post/${organizationId}/list`, {
      page,
      pageSize,
      orderBy: '',
      search,
      orderAsk: false,
      ...filter,
    });
  }

  public async createPost(
    organizationId: string,
    payload: CreatePostPayload,
  ): Promise<ApiResponse<{courseId: string}>> {
    return apiClient.post(`/post/${organizationId}/create`, payload);
  }
}

export default PostsApi;
